import RestApiModel from "@/api/Model/RestApiModel";
import api from '../index';

class ClassOfRisk extends RestApiModel {
  static getResourceEndpoint() {
    return '/facility-class-of-risks';
  }
}

export default ClassOfRisk;
